import React from "react";
import { Field, reduxForm } from "redux-form";
import { Button, Col, Row } from "antd";
import { renderField } from "utils/forms";

let StudentDisciplines = props => {
  const { handleSubmit } = props;
  return (
    <form onSubmit={handleSubmit}>
      <Row>
        <Col span={24}>
          <Field
            label="Disciplines"
            name="disciplines"
            component={renderField}
            type="string"
          />
        </Col>
      </Row>
      <Row>
        <Col span={8}>
          <Button
            style={{
              width: "100%"
            }}
            type="primary"
            htmlType="submit"
          >
            Save
          </Button>
        </Col>
      </Row>
    </form>
  );
};

export default reduxForm({
  form: "studentDisciplines"
})(StudentDisciplines);



// WEBPACK FOOTER //
// ./src/components/dashboard/student/forms/disciplines.js